import EdoProgramDetail from './EdoProgramDetail';

export default EdoProgramDetail;
